/**
 * 基础菜单 大数据
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>品牌浏览记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData"  v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
     <!-- <el-table-column align="center" type="selection" min-width="60">
      </el-table-column> -->
     <el-table-column prop="avatar" label="头像" min-width="100">
       <template slot-scope="scope">
         <el-avatar :src="scope.row.info.avatar"></el-avatar>
       </template>
     </el-table-column>
     <el-table-column sortable prop="name" label="用户名" min-width="150">
         <template slot-scope="scope">
           {{scope.row.info.name}}
         </template>
     </el-table-column>
     <el-table-column sortable prop="goods" label="浏览品牌" min-width="150">
     </el-table-column>
      <el-table-column sortable prop="phone" label="联系电话" min-width="150">
      </el-table-column>
      <el-table-column sortable prop="browse_time" label="浏览时间" min-width="150">
        <template slot-scope="scope">
          {{scope.row.browse_time}}秒
        </template>
      </el-table-column>
      <el-table-column sortable prop="click" label="点击次数" min-width="150">
      </el-table-column>
      <el-table-column sortable prop="time" label="上次访问日期" min-width="150">
      </el-table-column>
<!--
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="公司名称" prop="corporateName">
          <el-input @input="awdojo()" size="small" v-model="editForm.corporateName" auto-complete="off" placeholder="请输公司名称"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="name">
          <el-input @input="awdojo()" size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="class">
         <template slot-scope="scope">
           <el-select v-model="editForm.class" placeholder="请选择" @change="asdw(editForm.class)">
             <el-option
               v-for="item in brandListData"
               :key="item"
               :label="item"
               :value="item">
             </el-option>
           </el-select>
         </template>
        </el-form-item>
        <el-form-item label="经营" prop="nature">
          <el-input @input="awdojo()" size="small" v-model="editForm.nature" auto-complete="off" placeholder="请输入经营"></el-input>

        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input @input="awdojo()" size="small" v-model="editForm.phone" auto-complete="off" placeholder="请输入联系电话"></el-input>
           <!-- <input v-model="editForm.phone"  type="" name="" id="" value="" /> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { brandbrowse } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      brandListData:[
        '全屋定制工厂',
        '配套工厂',
        '门店'

      ],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        token: localStorage.getItem('logintoken'),
        ids : '',
        corporateName : '',
        name : '',
        nature : '',
        phone : '',
        class :''
      },
      // rules表单验证
      rules: {
        corporateName: [
          { required: true, message: '公司名称', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '联系人', trigger: 'blur' },
          ],
          class: [
            { required: true, message: '分类', trigger: 'blur' },
            ],
        nature: [
          { required: true, message: '经营', trigger: 'blur' },
          ],
        phone: [
          { required: true, message: '联系电话', trigger: 'blur' },
          ]
      },
      formInline: {
        name:'品牌',
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
awdojo(){
  this.$forceUpdate()
},
    // 获取公司列表
    getdata(parameter) {
      this.loading = true

      brandbrowse(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.ids = row._id.$oid
        this.editForm.corporateName = row.corporateName
        this.editForm.name = row.name
        this.editForm.nature = row.nature
        this.editForm.phone = row.phone
        this.editForm.class = row.class
      } else {
        this.title = '添加'
        this.editForm.ids = ''
        this.editForm.corporateName = ''
        this.editForm.name = ''
        this.editForm.nature = ''
        this.editForm.phone = ''
        this.editForm.class = ''

      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {

          deptDelete(row._id.$oid)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/shop/brandbrowse.vue